// import React from "react";
// import {
//   Button,
//   FormFieldSet,
//   Modal,
//   useFormHandler,
// } from "../../../../../../components";
// import {
//   BasepayOpetions,
//   Paymenttypeopetions,
//   PayPeriodoptions,
//   PayProfileoptions,
//   perDiemPaymentTypeOptions,
// } from "../../../../../../assets/data/projectData";

// const ReviseTimesheetsModal = ({ open, onClose }) => {
//   const { formData, errors, handleChange } = useFormHandler({
//     payProfile: "",
//     placements: "",
//     period: "",
//     Salary: "",
//     monthSalary: "",
//     DiemPaymentType: "",
//     BasePay2: "",
//     payCycle: "",
//     basePay: "",
//     onlyBasePayIsPaid: "",
//   });

//   return (
//     <Modal isOpen={open} onClose={onClose} title="REVISE" width="max-w-6xl">
//       <div className="grid grid-cols-3 gap-x-8 gap-y-6 max-w-7xl mt-4">
//         <FormFieldSet
//           type="select"
//           title={"Pay Profile"}
//           placeholder="Select Pay Profile"
//           value={formData.payProfile}
//           onChange={(value) => handleChange("payProfile", value)}
//           error={errors.payProfile}
//           showButton
//           showSearch
//           options={PayProfileoptions}
//         />
//         <FormFieldSet
//           type="select"
//           title={"Payment Type"}
//           placeholder="As Per placements"
//           value={formData.placements}
//           onChange={(value) => handleChange("placements", value)}
//           error={errors.placements}
//           options={Paymenttypeopetions}
//         />
//         <FormFieldSet
//           type="select"
//           title={"Pay period"}
//           placeholder="Select Pay period"
//           value={formData.period}
//           onChange={(value) => handleChange("period", value)}
//           error={errors.period}
//           options={PayPeriodoptions}
//         />
//       </div>
//       <div className="grid grid-cols-3 gap-x-8 gap-y-6 max-w-7xl mt-4">
//         <div className=" ml-2">
//           <FormFieldSet
//             type="checkbox"
//             size={"md"}
//             title={" "}
//             options={[
//               {
//                 label: "only Base Pay is Paid",
//                 value: true,
//               },
//             ]}
//             values={formData.onlyBasePayIsPaid}
//             onChange={(e) => handleChange("onlyBasePayIsPaid", e)}
//             multiple
//           />
//         </div>
//         <div className="col-span-1 flex gap-1  ">
//           <FormFieldSet
//             type="text"
//             title={"Enter Base Pay"}
//             placeholder="Enter"
//             value={formData.basePay}
//             onChange={(value) => handleChange("basePay", value)}
//             error={errors.basePay}
//           />
//           <div>
//             <FormFieldSet
//               type="select"
//               title={" "}
//               placeholder="Pay Cycle"
//               value={formData.payCycle}
//               onChange={(value) => handleChange("payCycle", value)}
//               error={errors.payCycle}
//               options={BasepayOpetions}
//             />
//           </div>
//         </div>
//         <FormFieldSet
//           type="text"
//           title={"Base Pay"}
//           placeholder="Enter"
//           value={formData.BasePay2}
//           onChange={(value) => handleChange("BasePay2", value)}
//           error={errors.BasePay2}
//         />
//       </div>
//       <div className="grid grid-cols-3 gap-x-8 gap-y-6 max-w-7xl mt-4">
//         <FormFieldSet
//           type="select"
//           title={"Per Diem Payment Type"}
//           placeholder="Not Applicable"
//           value={formData.DiemPaymentType}
//           onChange={(value) => handleChange("DiemPaymentType", value)}
//           error={errors.DiemPaymentType}
//           options={perDiemPaymentTypeOptions}
//         />
//       </div>
//       <div className="flex justify-end mt-4 gap-x-2 mb-4">
//         <Button title="Cancel" variant="outlined" onClick={onClose} />
//         <Button
//           title="Save"
//           variant="contained"
//           color="primary"
//           onClick={onClose}
//         />
//       </div>
//     </Modal>
//   );
// };

// export default ReviseTimesheetsModal;

import React, { useEffect } from "react";
import {
  Button,
  DevNote,
  FormFieldSet,
  Modal,
  showToast,
  useFormHandler,
} from "../../../../../../components";
import {
  BasepayOpetions,
  Paymenttypeopetions,
  PayPeriodoptions,
  PayProfileoptions,
  perDiemPaymentTypeOptions,
} from "../../../../../../assets/data/projectData";
import { v4 as uuidv4 } from "uuid";
import { addEmployeePayConfigure } from "../../../../../../redux/slices/payroll/payrollSlice";
import { filterEmptyValues } from "../../../../../../utils/filterEmptyValues";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { exactUTCDate } from "../../../../../../utils/dateFormator";
const ReviseTimesheetsModal = ({
  open,
  onClose,
  tableData,
  setTableData,
  setPredictData,
  predictData,
  filteredPlacementsActive,
  formattedPlacements,
  LCStypes,
  lcaList,
  empPayConfigData = [],
  handleCallApi,
  employeeProfileUiid,
  loginUserUiid,
  dispatch,
  formDataFromParent,
  placementId,
}) => {
  console.log("formdata in revise from parent", formDataFromParent);
  const {
    currentEmployee: { employeeDetails, loadedTabs },
    error,
    employees,
    totalCount,
  } = useSelector((state) => state.employee);

  const defaultValue = {
    payProfile: "",
    Placement: "",
    payPeriod: "",
    paymentType: "",
    onlyBasePayIsPaid: [],
    lcaFrom: "",
    lcaTo: "",
    basePayMonth: "",
    perDiemPaymentType: "",
    payType: "",
  };
  const rules = {
    payProfile: { type: "select", required: true },
    Placement: { type: "select", required: true },
    payPeriod: { type: "select", required: true },
  };

  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(defaultValue, rules);
  const handleonClose = () => {
    onClose();
    setFormData(defaultValue);
  };
  const handleLcaType = (value) => {
    handleChange("lcatype", value);
    const wageRate = parseFloat(formData?.lcaWages) || 0;
    const monthlyAmount = value === 2 ? wageRate / 12 : wageRate;
    handleChange("basePayMonth", Number(monthlyAmount.toFixed(2)));
  };
  // const handleChangePayProfile = (value) => {
  //   handleChange("payProfile", value);
  //   const find = filteredPlacementsActive.find(
  //     (data) => data.uiid === formData?.Placement
  //   );
  //   const startDate = find?.jobInfo?.startDate;
  //   if (!startDate) return;
  //   const selectedDate = new Date(startDate);
  //   const newTableData = [];
  //   const newPredictData = [];
  //   const formatDateLocal = (date) => date.toLocaleDateString("en-CA");

  //   // Helper: get last day of the month
  //   const getLastDayOfMonth = (date) =>
  //     new Date(date.getFullYear(), date.getMonth() + 1, 0);
  //   const today = dayjs()
  //   const dayOfMonth = today.date();
  // const monthsBack = dayOfMonth < 16 ? 2 : 1;
  // let current = today
  //   .subtract(monthsBack, 'month')
  //   .endOf('month')
  //     const labels = [];
  //     for (let i = 0; i < 5; i++) {
  //     const startOfMonth = current.startOf('month');
  //     const endOfMonth = current.endOf('month');
  //     const label = `${startOfMonth.format('MM/DD/YYYY')} to ${endOfMonth.format('MM/DD/YYYY')}`;
  //     labels.push({
  //       label,
  //       value: label,
  //       dates: { from: startOfMonth.toDate(), to: endOfMonth.toDate() },
  //     });
  //     current = current.add(1, 'month');
  //   }
  //   setTableData([]);
  //   setPredictData(labels);
  //   handleChange("payPeriod", "");
  // };
  
  
  // creates 5 dates from placeent startdate
  // const handleChangePayProfile = (value) => {
  //   handleChange("payProfile", value);
  //   const find = placementId.find(
  //     (data) => data.uiid === formData?.Placement?.value
  //   );

  //   const startDate = find?.jobInfo?.startDate;
  //   const endDate = find?.jobInfo?.endDate;
  //   if (!startDate) return;

  //   let selectedDate = dayjs(startDate);
  //   if (selectedDate.isAfter(dayjs())) {
  //     // if start date is in the future
  //     selectedDate = dayjs(startDate);
  //   } else {
  //     //;temporily commnet outed the correct code
  //     // if start date is in the past
  //     // selectedDate = dayjs();
  //     //temporay fix
  //     selectedDate = dayjs(startDate);
  //   }
  //   const newTableData = [];
  //   const newPredictData = [];

  //   // Helper to format date as YYYY-MM-DD
  //   const formatDate = (date) => dayjs(date).format("MM/DD/YYYY");

  //   // Helper to get last day of the month
  //   const getLastDayOfMonth = (date) => dayjs(date).endOf("month");

  //   // First period: from startDate to end of that month
  //   let periodStart = selectedDate.startOf("day");
  //   let periodEnd = selectedDate.endOf("day");
  //   const isBefore15th = periodStart.date() < 15;
  //   const isAfter15th = periodStart.date() >= 15;
  //   if (isBefore15th) {
  //     periodStart = periodStart.subtract(1, "month").startOf("month");
  //     periodEnd = periodEnd.subtract(1, "month").endOf("month");
  //   } else if (isAfter15th) {
  //     periodStart = periodStart.startOf("month");
  //     periodEnd = periodEnd.endOf("month");
  //   }

  //   for (let i = 0; i < 5; i++) {
  //     const payDay = periodEnd.add(1, "month").date(15); // 15th of next month

  //     const label = `${formatDate(periodStart)} to ${formatDate(periodEnd)}`;
  //     const payDayFormatted = formatDate(payDay);

  //     newPredictData.push({
  //       label,
  //       value: label,
  //     });

  //     newTableData.push({
  //       payPeriods: label,
  //       payDays: payDayFormatted,
  //     });

  //     // Next period: first and last day of the next month
  //     periodStart = periodEnd.add(1, "day").startOf("day");
  //     periodEnd = getLastDayOfMonth(periodStart);
  //   }

  //   setTableData([]); // Clear current data
  //   setPredictData(newPredictData); // Set new data
  //   handleChange("payPeriod", ""); // Clear selected pay period
  // };
  const handleChangePayProfile = (value) => {
    handleChange("payProfile", value);
    const find = placementId.find(
      (data) => data.uiid === formData?.Placement?.value
    );

    const startDate = find?.jobInfo?.startDate;
    const endDate = find?.jobInfo?.endDate;
    if (!startDate) return;

    let selectedDate = dayjs(exactUTCDate(startDate));
    console.log({startDate,selectedDate});
    if (selectedDate.isAfter(dayjs())) {
      // if start date is in the future
      selectedDate = dayjs(exactUTCDate(startDate));
    } else {
      //;temporily commnet outed the correct code
      // if start date is in the past
      // selectedDate = dayjs();
      //temporay fix
      selectedDate = dayjs(exactUTCDate(startDate));
    }
    const newTableData = [];
    const newPredictData = [];

    // Helper to format date as YYYY-MM-DD
    const formatDate = (date) => dayjs(date).format("MM/DD/YYYY");

    // Helper to get last day of the month
    const getLastDayOfMonth = (date) => dayjs(date).endOf("month");

    // First period: from startDate to end of that month
    let periodStart = selectedDate.startOf("day");
    let periodEnd = selectedDate.endOf("day");
    const isBefore15th = periodStart.date() < 15;
    const isAfter15th = periodStart.date() >= 15;
    if (isBefore15th) {
      periodStart = periodStart.subtract(1, "month").startOf("month");
      periodEnd = periodEnd.subtract(1, "month").endOf("month");
    } else if (isAfter15th) {
      periodStart = periodStart.startOf("month");
      periodEnd = periodEnd.endOf("month");
    }
    let numberOfMothsTillToday = dayjs().diff(selectedDate, "month") + 5 || 5;
    for (let i = 0; i < numberOfMothsTillToday; i++) {
      const payDay = periodEnd.add(1, "month").date(15); // 15th of next month

      const label = `${formatDate(periodStart)} to ${formatDate(periodEnd)}`;
      const payDayFormatted = formatDate(payDay);

      newPredictData.push({
        label,
        value: label,
      });

      newTableData.push({
        payPeriods: label,
        payDays: payDayFormatted,
      });

      // Next period: first and last day of the next month
      periodStart = periodEnd.add(1, "day").startOf("day");
      periodEnd = getLastDayOfMonth(periodStart);
    }

    setTableData([]); // Clear current data
    setPredictData(newPredictData); // Set new data
    handleChange("payPeriod", ""); // Clear selected pay period
  };

  // const handleChangePayPeriod = (value) => {
  //   const newTableData = [];
  //   handleChange("payPeriod", value);
  //   const formatDateLocal = (date) => date.toLocaleDateString("en-CA");
  //   // Helper: get last day of the month
  //   const getLastDayOfMonth = (date) =>
  //     new Date(date.getFullYear(), date.getMonth() + 1, 0);
  //   // Parse the exact start and end dates from the selected value (assumed format "YYYY-MM-DD to YYYY-MM-DD")
  //   const [startStr, endStr] = value.split(" to ");
  //   let periodStart = new Date(startStr);
  //   let periodEnd = new Date(endStr);
  //   // Add the exact period first
  //   const payDayForPeriod = new Date(
  //     periodEnd.getFullYear(),
  //     periodEnd.getMonth() + 1,
  //     15
  //   );
  //   newTableData.push({
  //     payPeriods: `${formatDateLocal(periodStart)} to ${formatDateLocal(
  //       periodEnd
  //     )}`,
  //     payDays: formatDateLocal(payDayForPeriod),
  //   });
  //   // Now generate next 4 full monthly periods
  //   for (let i = 0; i < 4; i++) {
  //     // Next period start: first day of the month after current periodEnd
  //     periodStart = new Date(
  //       periodEnd.getFullYear(),
  //       periodEnd.getMonth() + 1,
  //       1
  //     );
  //     // Next period end: last day of that month
  //     periodEnd = getLastDayOfMonth(periodStart);
  //     const payDay = new Date(
  //       periodEnd.getFullYear(),
  //       periodEnd.getMonth() + 1,
  //       15
  //     );
  //     newTableData.push({
  //       payPeriods: `${formatDateLocal(periodStart)} to ${formatDateLocal(
  //         periodEnd
  //       )}`,
  //       payDays: formatDateLocal(payDay),
  //     });
  //   }
  //   setTableData(newTableData);
  // };

  const handleChangePayPeriod = (value) => {
    const newTableData = [];
    handleChange("payPeriod", value);

    const formatDate = (date) => dayjs(date).format("MM/DD/YYYY");

    // Parse the selected period (assumes format: "YYYY-MM-DD to YYYY-MM-DD")
    const [startStr, endStr] = value.split(" to ");
    let periodStart = dayjs(startStr).startOf("day");
    let periodEnd = dayjs(endStr).endOf("day");

    // First pay period (the selected range)
    const payDayForPeriod = periodEnd.add(1, "month").date(15);

    newTableData.push({
      payPeriods: `${formatDate(periodStart)} to ${formatDate(periodEnd)}`,
      payDays: formatDate(payDayForPeriod),
    });

    // Generate next 4 full calendar month periods
    for (let i = 0; i < 4; i++) {
      // Start: 1st day of next month
      periodStart = periodEnd.add(1, "day").startOf("month");
      // End: last day of that month
      periodEnd = periodStart.endOf("month");

      const payDay = periodEnd.add(1, "month").date(15);

      newTableData.push({
        payPeriods: `${formatDate(periodStart)} to ${formatDate(periodEnd)}`,
        payDays: formatDate(payDay),
      });
    }

    setTableData(newTableData);
  };

  useEffect(() => {
    if (lcaList.length > 0) {
      const filterDatesActive = lcaList?.filter(
        (data) => new Date(data.endDate) > new Date()
      );
      const findActive = filterDatesActive[0];
      if (findActive) {
        if (formData.lcaWages !== findActive?.salaryInfo?.wageRate) {
          handleChange("lcaWages", findActive.salaryInfo.wageRate);
        }
        if (formData.basePay !== findActive?.startDate) {
          handleChange("basePay", findActive.startDate);
        }
        if (formData.payCycle !== findActive?.endDate) {
          handleChange("payCycle", findActive.endDate);
        }
        const startDate = findActive?.startDate
          ? new Date(findActive.startDate)
          : null;
        const endDate = findActive?.endDate
          ? new Date(findActive.endDate)
          : null;
        if (startDate && endDate) {
          const diffTime = Math.abs(endDate - startDate);
          const diffYears = diffTime / (1000 * 60 * 60 * 24 * 365);
          const newLcaType = diffYears >= 1 ? 2 : 1; // 2 = Yearly, 1 = Monthly
          if (formData.lcatype !== newLcaType) {
            handleChange("lcatype", newLcaType);
          }
          const wageRate = parseFloat(findActive?.salaryInfo?.wageRate) || 0;
          // If it's yearly (2), divide by 12 to get monthly; otherwise use the original
          const monthlyAmount = newLcaType === 2 ? wageRate / 12 : wageRate;
          handleChange("basePayMonth", Number(monthlyAmount.toFixed(2)));
        }
      }
    }
  }, [lcaList]);
  function parseDate(dateStr, separator = "/", format = "YYMMDD") {
    const dateArray = dateStr.split(separator).map(Number);
    let yyyy, mm, dd;
    switch (format) {
      case "YYMMDD":
        [yyyy, mm, dd] = dateArray;
        break;
      case "MMDDYY":
        [mm, dd, yyyy] = dateArray;
        break;
      default:
        throw new Error(`Unsupported date format: ${format}`);
    }
    return new Date(Date.UTC(yyyy, mm - 1, dd));
    // return new Date(Date.UTC(yyyy, mm - 1, dd)).toISOString();
  }
  const handleSave = () => {
    const isValid = validateAllFields();
    if (isValid) {
      const [startStr, endStr] = formData?.payPeriod.split(" to ");
      const fromConverted = parseDate(startStr, "/", "MMDDYY");
      const toConverted = parseDate(endStr, "/", "MMDDYY");
      const payload = {
        employeeId: employeeProfileUiid,
        jobId: formData?.Placement?.value,
        profile: formData?.payProfile?.value ?? formData?.payProfile,
        period: {
          // from: dayjs(startStr).startOf('day').toDate(),
          //  to: dayjs(endStr).endOf('day').toDate(),
          from: fromConverted,
          to: toConverted,
        },
        type: formData?.paymentType,
        basePay: formData?.basePayMonth,
        lca: {
          wages: Number(formData?.lcaWages),
          type: formData?.lcatype,
          period: {
            from: formData?.basePay,
            to: formData?.payCycle,
          },
        },
        addedBy: loginUserUiid,
      };
      // return;
      // const toCreatePayroll =
      //   employeeDetails?.employmentType == 4 &&
      //   formData?.Placement?.label !== "P1";
      // const submissionData = filterEmptyValues(payload);
      if (!formDataFromParent?.uiid) {
        showToast("Set Up Pay Configuration to revise it.", "error");
        return;
      }
      const submissionData = payload;

      const updatePayload = [
        {
          type: "SET",
          value: submissionData,
        },
      ];
      // console.log("toCreatePayroll in hndle revise", toCreatePayroll);
      console.log({uiidOFParent: formDataFromParent?.uiid});
      dispatch(
        addEmployeePayConfigure({
          coll: "EmpPayConfig",
          uiid: formDataFromParent?.uiid,
          payload: updatePayload,
          // ...(toCreatePayroll && { createPayroll: true }),
          // createPayroll: toCreatePayroll,
          onSuccess: () => {
            handleCallApi();
            handleonClose();
          },
        })
      );
    }
  };
  return (
    <Modal
      isOpen={open}
      onClose={handleonClose}
      title="REVISE"
      width="max-w-6xl"
    >
      <DevNote>Uiid of parent is {formDataFromParent?.uiid}</DevNote>
      <div className="grid grid-cols-3 gap-x-8 gap-y-6 max-w-7xl mt-4">
        <FormFieldSet
          //  type="select"
          type="placementsForPayConfigDropDown"
          title={"Select Placement"}
          placeholder="Select Placement"
          value={formData.Placement}
          onChange={(value) => {
            handleChange("Placement", value);
            setTableData([]);
            //  setPredictData([]);
            handleChange("payPeriod", "");
            handleChange("lcatype", "");
          }}
          parentValue={{
            entityId:
              employeeDetails?.employmentType === 4
                ? employeeDetails?.linkedTo?.uiid
                : employeeProfileUiid,
            entityType: employeeDetails?.employmentType === 4 ? true : false,
          }}
          error={errors.Placement}
          //  options={formattedPlacements}
        />
        <FormFieldSet
          type="allPayProfiles"
          title={"Pay Profile"}
          placeholder="Select Pay Profile"
          value={formData.payProfile}
          onChange={(value) => handleChangePayProfile(value)}
          error={errors.payProfile}
          showButton
          showSearch
          options={PayProfileoptions}
        />
        {console.log("predictData", predictData)}
        <FormFieldSet
          type="select"
          title={"Pay Period"}
          placeholder="Select Pay Period"
          value={formData.payPeriod}
          onChange={(value) => handleChangePayPeriod(value)}
          error={errors.payPeriod}
          // showButton
          // showSearch
          options={predictData}
        />
        <FormFieldSet
          type="select"
          title={"Payment Type"}
          placeholder="Select Payment Type"
          value={formData.paymentType}
          onChange={(value) => handleChange("paymentType", value)}
          error={errors.paymentType}
          options={Paymenttypeopetions}
        />
        <div>
          <FormFieldSet
            type="text"
            title={"Base pay"}
            placeholder="Enter Base pay"
            value={formData.basePayMonth}
            onChange={(value) => handleChange("basePayMonth", value)}
            error={errors.basePayMonth}
            options={BasepayOpetions}
          />
        </div>
        <FormFieldSet
          type="text"
          title={"LCA Wages"}
          placeholder="Enter LCA Wages"
          value={formData.lcaWages}
          onChange={(value) => handleChange("lcaWages", value)}
          error={errors.lcaWages}
          options={BasepayOpetions}
        />
        <FormFieldSet
          type="select"
          title={"LCA Type "}
          placeholder="LCA Type"
          value={formData.lcatype}
          onChange={(value) => handleLcaType(value)}
          error={errors.lcatype}
          options={LCStypes}
        />

        <div className="col-span-1 flex gap-1 ">
          <FormFieldSet
            type="datepicker"
            title={"LCA Time Period"}
            placeholder="01/01/2024"
            value={formData.basePay}
            onChange={(value) => handleChange("basePay", value)}
            error={errors.basePay}
            showDropdown={false}
          />
          <div>
            <FormFieldSet
              type="datepicker"
              title={" "}
              placeholder="01/01/2029"
              value={formData.payCycle}
              onChange={(value) => handleChange("payCycle", value)}
              error={errors.payCycle}
              options={BasepayOpetions}
              showDropdown={false}
            />
          </div>
        </div>
      </div>
      <div className="flex justify-end mt-4 gap-x-2 mb-4">
        <Button title="Cancel" variant="outlined" onClick={handleonClose} />
        <Button
          title="Save"
          variant="contained"
          color="primary"
          onClick={handleSave}
        />
      </div>
    </Modal>
  );
};

export default ReviseTimesheetsModal;
